import { showNotification } from 'shared/common/AppNotification/ui'

import { errorHandler } from 'shared/config/redux/helpers/baseQueryWithReAuth'

export const useHandleRequest = () => {
  const handleSuccess = (message: string) => {
    setTimeout(() => {
      showNotification({
        message,
        type: 'info',
      })
    }, 400)
  }

  const handleError = (err: any) => {
    const errMessage = errorHandler(err?.data)
    showNotification({
      message: errMessage,
      type: 'error',
    })
  }

  return { handleSuccess, handleError }
}
